// extracted by mini-css-extract-plugin
export var aircallIframe = "_js-3";
export var fabContainer = "_js-5";
export var fabRinging = "_js-6";
export var loadingOverlay = "_js-4";
export var pulse = "_js-7";
export var widgetContent = "_js-2";
export var widgetPanel = "_js-0";
export var widgetPanelExpanded = "_js-1";